import { DossierTransaction } from "../types/DossierTransaction";
import { ExpenseClaim } from "../types/ExpenseClaim";

export const mergeAndSortTransactionsAndExpenseClaims = (
  transactions: DossierTransaction[],
  expenseClaims: ExpenseClaim[]
) => {
  return [...transactions, ...expenseClaims].sort((a, b) => {
    return (
      new Date(b.transactionDate).getTime() -
      new Date(a.transactionDate).getTime()
    );
  });
};
